import { Hotel, Home, Search, AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import familyHomeTraditional from "@/assets/family-home-traditional.jpg";
import hotelExtendedStay from "@/assets/hotel-extended-stay.jpg";
import frvAnalysis from "@/assets/frv-analysis.jpg";
import catastropheAdjusters from "@/assets/catastrophe-adjusters.jpg";
import housingTeamCollaboration from "@/assets/housing-team-collaboration.jpg";

export const ServicesSection = () => {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-12 bg-background scroll-mt-20" aria-labelledby="services-heading">
      <div className="container mx-auto px-4">
        <h2 id="services-heading" className="text-3xl md:text-4xl font-bold text-center border-b border-border pb-4 mb-10">{t('services.placementServices')}</h2>

        <div className="max-w-5xl mx-auto space-y-8">
          {/* Housing - full width */}
          <div className="bg-muted/50 rounded-lg p-6">
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              <Home className="w-5 h-5 text-primary" />
              {t('services.housing.title')}
            </h3>
            <img src={familyHomeTraditional} alt="Happy family with pets standing in front of their traditional American style home" className="rounded-2xl shadow-2xl w-full h-[354px] object-cover mb-4" />
            <div className="space-y-3 text-muted-foreground text-sm">
              <p>{t('services.housing.p1')}</p>
              <p>{t('services.housing.p2')}</p>
              <p>{t('services.housing.p3')}</p>
            </div>
          </div>

          {/* Hotel, FRV, Catastrophe - three columns */}
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-muted/50 rounded-lg p-6">
              <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                <Hotel className="w-5 h-5 text-primary" />
                {t('services.hotel.title')}
              </h3>
              <img src={hotelExtendedStay} alt="Comfortable extended-stay hotel room with kitchen facilities" className="rounded-2xl shadow-2xl w-full mb-4" />
              <div className="space-y-3 text-muted-foreground text-sm">
                <p>{t('services.hotel.p1')}</p>
                <p>{t('services.hotel.p2')}</p>
              </div>
            </div>

            <div className="bg-muted/50 rounded-lg p-6">
              <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                <Search className="w-5 h-5 text-primary" />
                {t('services.frv.title')}
              </h3>
              <img src={frvAnalysis} alt="Placement specialist reviewing fair rental value analysis and market data" className="rounded-2xl shadow-2xl w-full mb-4" />
              <div className="space-y-3 text-muted-foreground text-sm">
                <p>{t('services.frv.p1')}</p>
                <p>{t('services.frv.p2')}</p>
              </div>
            </div>

            <div className="bg-muted/50 rounded-lg p-6">
              <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                <AlertTriangle className="w-5 h-5 text-primary" />
                {t('services.catastrophe.title')}
              </h3>
              <img src={catastropheAdjusters} alt="Insurance adjuster team working from temporary furnished housing during catastrophe response" className="rounded-2xl shadow-2xl w-full mb-4" />
              <div className="space-y-3 text-muted-foreground text-sm">
                <p>{t('services.catastrophe.p1')}</p>
                <p>{t('services.catastrophe.p2')}</p>
              </div>
            </div>
          </div>

          {/* Leave the Details to Us - full width across both columns */}
          <div className="py-8 bg-primary text-primary-foreground rounded-lg px-6">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="space-y-3 text-sm">
                <h3 className="text-2xl font-bold mb-2">{t('services.leaveDetails.title')}</h3>
                <p>{t('services.leaveDetails.p1')}</p>
                <p>{t('services.leaveDetails.p2')}</p>
                <p>{t('services.leaveDetails.p3')}</p>
                <p>{t('services.leaveDetails.p4')}</p>
              </div>
              <div>
                <img src={housingTeamCollaboration} alt="TPS Housing team collaborating together in office" className="rounded-2xl shadow-2xl w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};